import { Button, ButtonProps, FormWithRedirect, SaveButton, useListContext, useNotify } from "react-admin";
import { client, clientNoJson } from "../../dataProvider";
import { useState } from "react";
import { url as URL } from "../../constants";
import { CircularProgress, Dialog, DialogActions, DialogContent, Typography } from "@material-ui/core";
import { getUser } from "../../authProvider";
import { generateError } from "../../shared/utils";
import { useToggler } from "../../shared/hooks/useToggler";
import IconCancel from "@material-ui/icons/Cancel";
import { LuRouteOff } from "react-icons/lu";

export const ForceResetDeliveryStatusAndRouteBulkButton = (props: ButtonProps) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch } = useListContext();

  const { value, setTrue, setFalse } = useToggler();

  const handleSubmit = async () => {
    setLoading(true);

    client(`deliveries/bulk_force_reset_status`, {
      method: "POST",
      data: {
        ids: selectedIds
      }
    }).then((response) => {
      notify("Missioni resettate");
    })
      .catch((error) => {
        generateError(error, notify);
      })
      .finally(() => {
        setLoading(false);
        setFalse();
      })

      ;
    refetch();

  };

  return (
    <>
      <Button
        {...props}
        disabled={loading || selectedIds.length <= 0}
        label="Rimuovi da giro"
        title="Resetta lo stato e i giri delle missioni selezionate"
        onClick={(e) => {
          e.stopPropagation();
          setTrue();
        }}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <LuRouteOff />}
      </Button >
      <Dialog
        open={value}
        onClick={(e) => e.stopPropagation()}
        fullWidth
        maxWidth="sm"
      >
        <FormWithRedirect
          resource="project-collaborators"
          initialValues={{}}
          save={handleSubmit}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>
                <Typography>Sicuro di voler togliere le missioni dai giri e resettare gli stati?</Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  label="ra.action.cancel"
                  onClick={setFalse}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                  title="Resetta"
                  label="Resetta"
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};
